import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './authorization/service/auth-guard';
import {MainComponent} from './main.component';

export const routes: Routes = [
  {
    path: 'app',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'sensors',
        loadChildren: () => import('app/components/sensor/sensor.module').then(m => m.SensorModule),
        data: {
          resource: '/sensors',
          rights: ['readAll'],
        },
      },
      {
        path: 'external-interface',
        loadChildren: () => import('app/components/ext-interface/ext-interface.module').then(m => m.ExtInterfaceModule),
        data: {
          resource: '/external-interfaces',
          rights: ['readAll'],
        },
      },
    ],
  },
  {path: '**', redirectTo: '404'},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
})
export class MainRoutingModule {

}
